<template>
  <page :title="title" :breadcrumb="breadcrumb">
    <!-- <div slot="pageAction">
      <div class="actionBlock">
        <v-menu offset-y :min-width="250">
          <v-btn text color="secondary" v-on="on">
            More Links...
            <v-icon right>mdi-link</v-icon>
          </v-btn>
          <side-function-menu :items="sideFunction" @doClick="$router.push($event)"></side-function-menu>
        </v-menu>
      </div>
    </div> -->
    <v-card>
      <!-- <v-card-title v-if="!newPolType">
        <div class="title" >{{polType}} - {{polTypeDesc}}</div>
      </v-card-title> -->
      <transition name="slide-x-transition" mode="out-in">
        <router-view @refresh="doInit"></router-view>
      </transition>
    </v-card>
  </page>
</template>

<script>
import { mapGetters } from 'vuex'
import { expandURI } from '@/utils/ajax'
// import SideFunctionMenu from '@/components/core/claimManagement/sideFunction/SideFunctionMenu'
export default {
  data() {
    return {
      title: 'Manage Policy Type',
      breadcrumb: [],
      sideFunction: [
        {
          text: 'Policy Type',
          icon: 'mdi-launch',
          iconColor: 'primary',
          params: { name: 'polTypeDet' }
        }
      ],
      polTypeDesc: null
    }
  },
  created() {
    this.doInit()
  },
  methods: {
    async doPolType() {
      const apiURI = this.menu.getPolType
      if (apiURI) {
        try {
          const expand = {
            polType: this.polType
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          if (data) {
            this.polTypeDesc = data.polType.polTypeDesc
          }
        } catch (err) {
          this.polTypeDesc = null
        }
      }
    },
    doInit() {
      this.doBreadcrumb()
      if (!this.newPolType) {
        this.sideFunction.push({
          text: 'Permitted Business Class',
          icon: 'mdi-launch',
          iconColor: 'primary',
          params: { name: 'polTypeCls' }
        })
      }
      this.doPolType()
    },
    doBreadcrumb() {
      switch (this.$route.name) {
        case 'polTypeDet': {
          this.breadcrumb = this.derieveBreadcrumbByName('polTypeDet')
          this.title = 'Policy Type'
          break
        }
        case 'polTypeCls': {
          this.breadcrumb = this.derieveBreadcrumbByName('polTypeCls')
          this.title = 'Permitted Business Class'
          break
        }
      }
    }
  },
  computed: {
    ...mapGetters(['derieveBreadcrumbByName']),
    menu() {
      return this.$store.state.polTypeParam.menu
    },
    newPolType() {
      return this.polType === 'new'
    }
  },
  watch: {
    '$route.name'(value) {
      this.doBreadcrumb()
    }
  },
  // components: {
  //   SideFunctionMenu
  // },
  props: ['polType']
}
</script>

<style>
</style>
